import { onError } from '@apollo/client/link/error';

const hasGraphqlValidationFailed = graphQLError =>
    [/GRAPHQL_VALIDATION_FAILED/gi].some(r =>
        graphQLError?.extensions?.code.match(r)
    );

const getGraphQLErrorStackTrace = graphQLError => {
    return graphQLError?.extensions?.exception?.stacktrace;
};

const ifExistsWriteGraphQLValidationErrorStacktrace = graphQLError => {
    if (hasGraphqlValidationFailed(graphQLError)) {
        const stacktrace = getGraphQLErrorStackTrace(graphQLError);

        // eslint-disable-next-line no-console
        console.error('\n', stacktrace?.join('\n'), '\n');
    }
};

export const errorLogLink = () =>
    onError(({ graphQLErrors }) => {
        if (graphQLErrors) {
            graphQLErrors.forEach(async graphQLError => {
                ifExistsWriteGraphQLValidationErrorStacktrace(graphQLError);
            });
        }
    });
